export const getUserState = (state: any) => state.user;
